import React from "react";
import Layout from "../Layout";
import {
  Grid,
  makeStyles,
  Typography,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";
import {
  FileCopy,
  Edit,
  Delete,
} from '@material-ui/icons/';

// ADD 2024.03.31
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Collapse from "@material-ui/core/Collapse";

import { withRouter } from "react-router";
import useApi from "Hooks/Admin/useApi";
import useAuth from "Hooks/Admin/useAuth";
import MuiAlert from "@material-ui/lab/Alert";

import "dayjs/locale/ja";
import dayjs from "dayjs";
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
dayjs.locale("ja");
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    // overflow: "auto",
    flexDirection: "column",
  },
  wrapper: {
    marginTop: theme.spacing(2),
  },
  table: {
    // width: "1600px",
    overflowX: "auto",
  },
  nthOfTypeOddRow: {
    backgroundColor: "#eee",
  },
  alert: {
    marginTop: theme.spacing(2),
  },
  dateCol: {
    width: "170px",
  },
  buttonCol: {
    textAlign: "center",
    width: "180px",
  },
  buttonRed: {
    color: "rgb(220, 0, 78)",
    "&:hover": {
      backgroundColor: "rgba(220, 0, 78, 0.04)",
    },
  },
  icon: {
    textAlign: "center",
    width: "50px",
  },
  viewRow: {
    fontWeight: "bold",
  },
}));

function InformationUrls(props) {
  const { request } = useApi();
  const auth = useAuth();
  const classes = useStyles();

  const [informationUrls, setInformationUrls] = React.useState([]);
  const [isShowModal, setIsShowModal] = React.useState(false);
  const [copyId, setCopyId] = React.useState(null);
  const [copyTitle, setCopyTitle] = React.useState(null);
  const [success, setSuccess] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState(null);

  // ADD 2024.03.31
  const [isDelShowModal, setIsDelShowModal] = React.useState(false);
  const [deleteId, setDeleteId] = React.useState(null);
  const [nextType, setNextType] = React.useState(null);
  const [viewInfo, setViewInfo] = React.useState(0);

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - ヘッダー告知一覧";

    if (props.location.search.indexOf("create") > -1) {
      setSuccess(true);
      setSuccessMessage("登録が完了しました");
    }
    // ADD 2024.03.31
    if (props.location.search.indexOf("edit") > -1) {
      setSuccess(true);
      setSuccessMessage("更新が完了しました");
    }
  }, []);

  React.useEffect(() => {
    if (!auth.state.token) {
      return;
    }
    fetchInformationUrls();
  }, [auth.state.token]);

  const fetchInformationUrls = () => {
    request({
      method: "GET",
      url: `admin/information_urls`,
    }).then((result) => {
      setInformationUrls(result.data.data);
    });
  };

  // ADD 2024.03.31 削除追加
  const openDeleteDialog = (id, date) => {
    setDeleteId(id);
    setIsDelShowModal(true);
  };
  // ADD 2024.03.31 削除追加
  const deleteInformation = () => {
    request({
      method: "DELETE",
      url: `admin/information_urls/${deleteId}`,
    }).then(() => {
      fetchInformationUrls();
      setIsDelShowModal(false);
      setSuccess(true);
      setSuccessMessage("削除が完了しました");
    });
  };

  // 表示中のヘッダー告知をチェックし、存在すれば確認ダイアログを表示
  // Update 2024.03.31 type追加で複製と更新を切り分ける
  const checkDisplaying = (id = null, type = null) => {
    if (viewInfo > 0 && informationUrls.length > 0) {
      // 最新のヘッダー告知情報
      const latestInformationUrl = informationUrls[viewInfo - 1];

      const latestInfoValidFrom = 
        dayjs(latestInformationUrl.valid_from).format("YYYY-MM-DD HH:mm:ss");
      const latestInfoValidUntil = 
        dayjs(latestInformationUrl.valid_until).format("YYYY-MM-DD HH:mm:ss");
      
      const today = dayjs().format("YYYY-MM-DD HH:mm:ss");
  
      // 現在有効な掲載期間であった場合、ダイアログを表示
      if (dayjs(today).isSameOrAfter(dayjs(latestInfoValidFrom)) &&
          dayjs(today).isSameOrBefore(dayjs(latestInfoValidUntil))) {
            openDialog(id, latestInformationUrl.title, type);
      } else {
        if (type == 'edit') {
          props.history.push(`/admin/informationUrls/edit/${id}`);
        } else {
          props.history.push(`/admin/informationUrls/create?copyId=` + id);
        }
      }
    } else {
      if (type == 'edit') {
        props.history.push(`/admin/informationUrls/edit/${id}`);
      } else {
        props.history.push(`/admin/informationUrls/create?copyId=` + id);
      }
    }
  }; 

  // ADD 2024.03.31 現在有効な掲載期間のヘッダー告知にフラグを立てる
  React.useEffect(() => {
    let c = 0;
    informationUrls.map(
      function (row, index) {
        const latestInfoValidFrom  = dayjs(row.valid_from).format("YYYY-MM-DD HH:mm:ss");
        const latestInfoValidUntil = dayjs(row.valid_until).format("YYYY-MM-DD HH:mm:ss");
        const today = dayjs().format("YYYY-MM-DD HH:mm:ss");
        if (c == 0 && 
            dayjs(today).isSameOrAfter(dayjs(latestInfoValidFrom)) &&
            dayjs(today).isSameOrBefore(dayjs(latestInfoValidUntil))) {
              setViewInfo(index + 1);
              c++;
        } 
      }
    );
  }, [informationUrls]);

  const openDialog = (id = null, title = null, type = null) => {
    if (id != null) {
      setCopyId(id);
    }
    if (title != null) {
      setCopyTitle(title);
    }
    if (type != null) {
      setNextType(type);
    }
    setIsShowModal(true);
  };

  function Row(props) {
    const { row, index } = props;
    const isNthOfTypeOdd = index % 2 === 0 ? false : true ;
    const [open, setOpen] = React.useState(false);
  
    // Update 2024.03.31 更新、削除機能追加
    return (
      <React.Fragment>
        <TableRow className={isNthOfTypeOdd ? classes.nthOfTypeOddRow : null}>
          <TableCell className={classes.icon}>
            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell style={viewInfo == index ? {color: "inherit"} : {color: "#c0c0c0"}}>{row.title}</TableCell>
          <TableCell style={viewInfo == index ? {color: "inherit"} : {color: "#c0c0c0"}} className={classes.dateCol}>{row.valid_from ? dayjs(row.valid_from).format("YYYY/MM/DD HH:mm:ss") : '-'}</TableCell>
          <TableCell style={viewInfo == index ? {color: "inherit"} : {color: "#c0c0c0"}} className={classes.dateCol}>{row.valid_until ? dayjs(row.valid_until).format("YYYY/MM/DD HH:mm:ss") : '-'}</TableCell>
          <TableCell style={viewInfo == index ? {color: "inherit"} : {color: "#c0c0c0"}} className={classes.buttonCol}>
          <IconButton 
              color="primary" 
              aria-label="add an Edit"
              style={viewInfo == index ? {border: "none"} : {color: "#b0c4de"}}
              onClick={() => checkDisplaying(row.id, 'edit')}
            >
              <Edit />
            </IconButton>
            <IconButton 
              color="primary" 
              aria-label="add an FileCopy"
              style={viewInfo == index ? {border: "none"} : {color: "#b0c4de"}}
              onClick={() => checkDisplaying(row.id, 'copy')}
            >
              <FileCopy />
            </IconButton>
            <IconButton 
              className={classes.buttonRed} 
              aria-label="add an Delete"
              style={viewInfo == index ? {border: "none"} : {color: "#ffb6c1"}}
              onClick={() => openDeleteDialog(row.id, row.deleted_at)}
            >
              <Delete />
            </IconButton>

          </TableCell>
        </TableRow>

        <TableRow className={isNthOfTypeOdd ? classes.nthOfTypeOddRow : null}>
          <TableCell style={viewInfo == index ? {color: "inherit", paddingBottom: 0, paddingTop: 0} : {color: "#c0c0c0", paddingBottom: 0, paddingTop: 0}} colSpan={5} >
            <Collapse in={open} timeout="auto" unmountOnExit>
              <p>概要：{row.desc}</p>
            </Collapse>
          </TableCell>
        </TableRow>

      </React.Fragment>
    );
  };

  // Update 2024.03.31 更新、削除機能追加
  return (
    <Layout
      content={
        <>
          <Grid>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" color="primary">
                ヘッダー告知一覧
              </Typography>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell>　</TableCell>
                    <TableCell>タイトル</TableCell>
                    <TableCell>掲載開始日時</TableCell>
                    <TableCell>掲載終了日時</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {informationUrls.map(
                    function (row, index) {
                      return <Row index={index+1} row={row} />
                    }
                  )}
                </TableBody>
              </Table>
            </Paper>
            {success && (
            <Grid>
              <MuiAlert
                elevation={6}
                variant="filled"
                severity="success"
                className={classes.alert}
              >
                {successMessage}
              </MuiAlert>
            </Grid>
            )}
            <Grid container justifyContent="center" className={classes.wrapper}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => checkDisplaying()}
              >
                新規ヘッダー告知登録
              </Button>
            </Grid>
          </Grid>

          <Dialog open={isShowModal} onClose={() => setIsShowModal(false)}>
            <DialogContent>
              <DialogContentText>
                現在“{copyTitle}”を表示中ですが宜しいですか？
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button color="primary" onClick={() => props.history.push(
                nextType=="edit" ? `/admin/informationUrls/edit/${copyId}` : `/admin/informationUrls/create?copyId=` + copyId
                )}>
                はい
              </Button>
              <Button color="primary" onClick={() => setIsShowModal(false)}>
                いいえ
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog open={isDelShowModal} onClose={() => setIsDelShowModal(false)}>
            <DialogContent>
              <DialogContentText>
                本当に削除してよろしいですか？
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button color="primary" onClick={() => deleteInformation()}>
                はい
              </Button>
              <Button color="primary" onClick={() => setIsDelShowModal(false)}>
                いいえ
              </Button>
            </DialogActions>
          </Dialog>
        </>
      }
    />
  );
}

export default withRouter(InformationUrls);
